import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import partnerApi from '../api';

const POLL_INTERVAL_MS = 10_000; // 10 seconds

export default function RegisterPending() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const partnerId = state?.partner_id;
  const [status, setStatus] = useState('pending_review');
  const [crawlerStatus, setCrawlerStatus] = useState('not_started');

  useEffect(() => {
    if (!partnerId) return;

    const poll = async () => {
      try {
        const { data } = await partnerApi.get(`/onboarding/status/${partnerId}`);
        setStatus(data.status);
        setCrawlerStatus(data.crawler_status);
        if (data.status === 'active') {
          navigate('/login', {
            state: { message: 'Your account is live! Sign in to get started.' },
            replace: true,
          });
        }
      } catch (err) { // eslint-disable-line no-unused-vars
        // Swallow — keep polling
      }
    };

    poll();
    const id = setInterval(poll, POLL_INTERVAL_MS);
    return () => clearInterval(id);
  }, [partnerId, navigate]);

  if (!partnerId) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-surface-page px-4">
        <div className="text-center">
          <p className="text-sm text-ink-secondary">No application found.</p>
          <Link to="/register" className="mt-2 block text-sm font-medium text-raspberry-600 hover:underline">
            Apply as a brand partner
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-surface-page px-4 text-center">
      {/* Logo */}
      <span className="mb-8 font-serif text-2xl text-ink">
        <span className="text-raspberry-600">mahi</span>.fashion
      </span>

      <div className="w-full max-w-md rounded-2xl border border-hairline bg-surface p-10 shadow-sm">
        {/* Animated clock / spinner */}
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-raspberry-50">
          <span className="text-2xl">⏳</span>
        </div>

        <h1 className="text-lg font-semibold text-ink">Application received</h1>
        <p className="mt-2 text-sm text-ink-secondary">
          Our team is reviewing your application. This typically takes less than 24 hours.
          We'll notify you via SMS when your account is approved.
        </p>

        {/* Status pill */}
        <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-hairline bg-surface-page px-4 py-1.5">
          <span className="h-2 w-2 animate-pulse rounded-full bg-status-warning" />
          <span className="text-xs font-medium text-ink-secondary capitalize">
            {status.replace('_', ' ')}
          </span>
        </div>

        <p className="mt-6 text-xs text-ink-muted">
          This page checks automatically every 10 seconds.
          <br />
          You can safely close it — you'll receive an SMS when approved.
        </p>
      </div>

      <p className="mt-6 text-xs text-ink-muted">
        Questions?{' '}
        <a href="mailto:partners@mahi.fashion" className="font-medium text-raspberry-600 hover:underline">
          partners@mahi.fashion
        </a>
      </p>
    </div>
  );
}
